import { useEffect, useRef, useState } from 'react';

/**
 * Účtenka z šablony OS (`resources/views/uctenka`) — HTML ze serveru
 * v izolovaném rámu, zmenšené na šířku místa. Stejné HTML jde do tisku,
 * na stránku objednávky i do PDF, takže náhled je přesně to, co vyjede.
 *
 * @param {string} html       celý dokument z `/…/uctenka` (`html`)
 * @param {number} sirka      šířka, pro kterou je HTML vykreslené (576 / 384 / 360)
 * @param {number} [zobrazit] jak široké ho ukázat (px); výchozí = celé
 */
export default function UctenkaHtml({ html, sirka = 360, zobrazit = null, stin = true }) {
    const ram = useRef(null);
    const [vyska, setVyska] = useState(600);
    const meritko = zobrazit ? zobrazit / sirka : 1;

    useEffect(() => {
        const el = ram.current;
        if (!el) return undefined;
        const zmer = () => {
            const doc = el.contentDocument;
            if (doc?.body) setVyska(Math.ceil(doc.documentElement.scrollHeight));
        };
        el.addEventListener('load', zmer);
        // Písma se dotahují až po načtení — výška se po nich ještě změní
        const t = setTimeout(zmer, 600);
        return () => { el.removeEventListener('load', zmer); clearTimeout(t); };
    }, [html]);

    return (
        <div style={{ width: sirka * meritko, height: vyska * meritko, overflow: 'hidden', flexShrink: 0, borderRadius: 4, boxShadow: stin ? '0 2px 14px rgba(0,0,0,0.3)' : 'none', background: '#fff' }}>
            <iframe
                ref={ram}
                title="Účtenka"
                srcDoc={html}
                sandbox="allow-same-origin"
                style={{ width: sirka, height: vyska, border: 0, display: 'block', transform: `scale(${meritko})`, transformOrigin: '0 0' }}
            />
        </div>
    );
}
